module.exports = __webpack_public_path__ + "static/media/REWARDS@3x.2bd3f3ce.png";